import React, { useCallback, useState } from 'react';
import IngredientsModal from './IngredientsModal';
import { showAlertSnackBar } from 'utils/Global';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import useVendorsList from './hooks/useVendorsList';
import { saveVendor } from 'business/services/IngredientService';
import { ResponseType } from 'business/models/Models';
import { IngredientsModalType } from './IngredientEnums';

const TYPES_COLUMNS = [
  {
    accessor: 'name',
    Header: 'Vendor',
    editOptions: { inputType: 'text' },
  },
];

const VendorModal = (props) => {
  const { showVendorModal, setShowVendorModal } = props;
  const [refetchCounter, setRefetchCounter] = useState(0);
  const vendorsList = useVendorsList(showVendorModal, refetchCounter);

  const saveVendorsList = useCallback(async (allRows) => {
    const result = await saveVendor(allRows);
    if (result.responseType == ResponseType.Success) {
      showAlertSnackBar(
        EAlertType.SUCCESS,
        ESnackBarPosition.TOP,
        'Vendors have been updated successfully!',
      );
      return true;
    } else if (result.responseType == ResponseType.Warning) {
      showAlertSnackBar(EAlertType.WARNING, ESnackBarPosition.TOP, result.message);
      setRefetchCounter(refetchCounter + 1);
      return false;
    }
  }, []);

  return (
    <IngredientsModal
      id='vendormodal-wrapper'
      columns={TYPES_COLUMNS}
      saveModal={saveVendorsList}
      rowsData={vendorsList}
      showModal={showVendorModal}
      setShowModal={setShowVendorModal}
      dialogClassName={'w-96'}
      heading="Vendor"
      ingredientsModalType={IngredientsModalType.Vendor}
    />
  );
};

export default VendorModal;
